// Object utility methods

export default function objectByPath(obj, path) {
  path = path
    .replace(/\[(\w+)\]/g, '.$1')
    .replace(/^\./, '')
    .split('.')

  for (let i = 0, n = path.length; i < n; ++i) {
    const pathPart = path[i]
    if (pathPart in obj) {
      obj = obj[pathPart]
    } else {
      break
    }
  }
  return obj
}
